module.exports = __webpack_public_path__ + "static/img/hh-statement.a4a71cfd.png";